import { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';

// components
import { SbSharedRefineMenuCaratWeightRange } from './SbSharedRefineMenuCaratWeightRange.tsx';
import { SbSharedRefineMenuRadioSelectList } from '../SbSharedRefineMenuRadioSelect/SbSharedRefineMenuRadioSelectList.jsx';

// styles
import styles from './SbSharedRefineMenuCaratWeight.module.css';

import { type FilterValue } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect.tsx';
import { type SbSharedRefineMenuCaratWeight_itemSearch$key } from './__generated__/SbSharedRefineMenuCaratWeight_itemSearch.graphql.ts';

const itemSearchFragment = graphql`
    fragment SbSharedRefineMenuCaratWeight_itemSearch on ItemSearchQueryConnection {
        ...SbSharedRefineMenuRadioSelectList_itemSearch
        ...SbSharedRefineMenuCaratWeightRange_itemSearch
    }
`;

type Props = {
    itemSearch: SbSharedRefineMenuCaratWeight_itemSearch$key;
    filterName: string;
    filter: { values: ReadonlyArray<FilterValue | null | undefined> } | null | undefined;
    applyOnBlur?: boolean;
};

export const SbSharedRefineMenuCaratWeight: FC<Props> = ({
    itemSearch: itemSearchRef,
    filterName,
    filter,
    applyOnBlur,
}) => {
    const itemSearch = useFragment(itemSearchFragment, itemSearchRef);

    // The preset multi-select carat buckets are all the other items in "values" array.
    const [filterValue, ...presetValues] = filter?.values ?? [];

    return (
        <div className={styles.container}>
            <SbSharedRefineMenuCaratWeightRange
                itemSearch={itemSearch}
                filterName={filterName}
                filterValue={filterValue}
                applyOnBlur={applyOnBlur}
            />
            <SbSharedRefineMenuRadioSelectList
                values={presetValues}
                filterName={filterName}
                itemSearch={itemSearch}
                notDismissable={false}
                collapsedItemCount={5}
            />
        </div>
    );
};
